import BookingStatusMap from '@/shared/constants/booking/BookingStatusMap'

/**
 * Adds a display-ready `statusLabel` (derived from `status` via BookingStatusMap)
 * to a booking and each of its `blockDetails` entries, if present.
 * @param {Object} booking - Raw booking object from the search-bookings endpoint.
 * @returns {Object} A new booking object with `statusLabel` added.
 */
const withStatusLabel = (booking) => ({
  ...booking,
  statusLabel: BookingStatusMap[booking.status],
  blockDetails:
    booking?.blockDetails?.map((block) => ({
      ...block,
      statusLabel: BookingStatusMap[block.status],
    })) ?? booking.blockDetails,
})

export { withStatusLabel }
